import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=a2734e1c&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=a2734e1c&prod&lang=scss&scoped=true"
import style1 from "./ItemList.vue?vue&type=style&index=1&id=a2734e1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2734e1c",
  null
  
)

export default component.exports